import { useEffect, useState } from 'react';
import { getKeyValuePairs } from '../utils/objects';

interface Sizes {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
}

export const sizes: Sizes = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px'
};

const isMatch = (media: Extract<keyof Sizes, string>): boolean => {
  if (media === 'xs') {
    const query = `(min-width: ${sizes.sm})`;
    return !window.matchMedia(query).matches;
  } else {
    const query = `(min-width: ${sizes[media]})`;
    return window.matchMedia(query).matches;
  }
};

const findClosest = (): Extract<keyof Sizes, string> => {
  const queries = getKeyValuePairs(sizes).map((x) => x.key as Extract<keyof Sizes, string>);
  for (let i = queries.length - 1; i >= 1; i--) {
    if (isMatch(queries[i])) {
      return queries[i];
    }
  }
  return 'xs';
};

export const useClosestMedia = () => {
  const [closest, setClosest] = useState<Extract<keyof Sizes, string>>();

  useEffect(() => {
    const listener = () => setClosest(findClosest());
    listener();
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener); //Cleanup
  }, []);

  return closest;
};

export const useMediaQuery = (screen: Extract<keyof Sizes, string>) => {
  const [matches, setMatches] = useState<boolean>();

  useEffect(() => {
    const listener = () => setMatches(isMatch(screen));
    listener();
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [screen]);

  return matches;
};
